import { TournamentState } from '@ps/web-poker-tile-mappers';

import { mttDefaultState } from '@swf/poker';

import { SundayMillionTab } from '../types';

import type { PokerSundayMillionState } from './types';

export const defaultState: PokerSundayMillionState = {
  ...mttDefaultState,
  activeFilters: {},
  isHydrated: false,
  selectedTab: SundayMillionTab.Main
};

export const satelliteActiveFilters = {
  state: [
    TournamentState.LATE_REGISTRATION,
    TournamentState.REGISTERING,
    TournamentState.RUNNING,
    TournamentState.PHASE
  ]
};
